import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Home from "./pages/Home";
import CustomerList from "./components/Customer/CustomerList";
import CreateCustomer from "./components/Customer/CreateCustomer";
import CustomerProfile from "./components/Customer/CustomerProfile";
import EditCustomerProfile from "./components/Customer/EditCustomerProfile";
import CustomerGroupManagement from "./components/CustomerGroup/GroupManagement";
import CustomerGroupList from "./components/Customer/CustomerGroupList";
import DeliveryOptions from "./components/Delivery/DeliveryOptions";
import CreateDelivery from "./components/Delivery/CreateDelivery";
import DeliveryHistory from "./components/Delivery/DeliveryHistory";
import InvoiceGenerator from "./components/Invoice/InvoiceGenerator";
import BulkInvoiceGenerator from "./components/Invoice/BulkInvoiceGenerator";
import PaymentDue from "./pages/PaymentDue"; // ✅ Payment Due Page Import किया
import { SpeedInsights } from "@vercel/speed-insights/react";
import Product from "./pages/Product";
import Deliveries from "./pages/Deliveries";
import Payment from "./pages/Payment";
import ProductLoadingUnloading from "./pages/ProductLoadingUnloading";
import ViewLoadingUnloadingRecords from "./pages/ViewLoadingUnloadingRecords";
import ReportCustomerDeliverySummary from "./components/Report/ReportCustomerDeliverySummary";
import InvoiceList from "./components/Catering/InvoiceList";
import InvoiceDetails from "./components/Catering/InvoiceDetails";
import CreateInvoiceForm from "./components/Catering/CreateInvoiceForm";
import Reports from "./pages/Reports";
import CustomerBackupDownloader from "./components/Invoice/CustomerBackupDownloader"; // ✅ Customer Backup Downloader Import किया

const urlPayment = "/paymentconfig.json"; // ✅ Local JSON Path

function App() {
  const [loading, setLoading] = useState(true);
  const [isPaymentDue, setIsPaymentDue] = useState(false);

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        const response = await fetch(urlPayment);
        const data = await response.json();

        console.log("📥 Local API Response:", data);
        if (data.payment_status === "pending") {
          setIsPaymentDue(true);
        }
      } catch (error) {
        console.error("❌ Error fetching local payment status:", error);
      } finally {
        setLoading(false);
      }
    };

    checkPaymentStatus();
  }, []);

  if (loading) {
    return (
      <div className="text-center text-lg p-10">
        ⏳ Checking Payment Status...
      </div>
    );
  }

  return (
    <Router>
      <SpeedInsights />
      {/* Toaster with custom styles */}
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          style: {
            background: "#333",
            color: "#fff",
            padding: "16px",
            fontSize: "14px",
            borderRadius: "8px",
          },
          success: {
            style: {
              background: "#4caf50", // Custom success color
            },
          },
          error: {
            style: {
              background: "#f44336", // Custom error color
            },
          },
        }}
      />
      <Routes>
        {/* अगर पेमेंट ड्यू है तो सीधे Payment Due Page दिखाएगा */}
        {isPaymentDue ? (
          <Route path="*" element={<PaymentDue />} />
        ) : (
          <>
            {/* Public Routes */}
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<Register />} />
            {/* Protected Routes */}
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/home" element={<Home />} />
              <Route path="/customer" element={<CustomerList />} />
              <Route
                path="/customer-profile/:id"
                element={<CustomerProfile />}
              />
              <Route
                path="/edit-customer/:id"
                element={<EditCustomerProfile />}
              />
              <Route path="/create-customer" element={<CreateCustomer />} />
              <Route
                path="/customer-group-management"
                element={<CustomerGroupManagement />}
              />
              <Route path="/customer-group" element={<CustomerGroupList />} />
              <Route
                path="/delivery-options/:id"
                element={<DeliveryOptions />}
              />
              <Route path="/create-delivery" element={<CreateDelivery />} />
              <Route path="/delivery-history" element={<DeliveryHistory />} />
              <Route path="/invoice-generator" element={<InvoiceGenerator />} />
              <Route
                path="/all-customers-invoice"
                element={<BulkInvoiceGenerator />}
              />
              <Route path="/product" element={<Product />} />
              <Route path="/deliveries" element={<Deliveries />} />
              <Route path="/payment" element={<Payment />} />
              <Route path="/invoice" element={<BulkInvoiceGenerator />} />
              <Route
                path="/products/loading-unloading"
                element={<ProductLoadingUnloading />}
              />
              <Route
                path="/view-records"
                element={<ViewLoadingUnloadingRecords />}
              />

              <Route
                path="/report/daily-summary"
                element={<ReportCustomerDeliverySummary />}
              />

              <Route path="/report/customer-backup" element={<CustomerBackupDownloader />} />


              <Route path="/reports" element={<Reports />} />

              {/* Catering invoice ke liye routes */}
              <Route path="/catering-invoices" element={<InvoiceList />} />
              <Route path="/invoices/:id" element={<InvoiceDetails />} />
              <Route path="/catering-invoice/create" element={<CreateInvoiceForm />} />
            </Route>
            {/* Catch-All Route (404 Not Found) */}
            <Route path="*" element={<NotFound />} /> {/* Catch-all route */}
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
